'use client';

import type React from 'react';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import {useRipple} from '../../hooks/useRipple';
import styles from './Ripple.module.scss';

export interface RippleRef {
  trigger: (
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
  ) => void;
}

export const Ripple = forwardRef<RippleRef>((_, ref) => {
  const {createRipple, ripples} = useRipple();
  const containerRef = useRef<HTMLSpanElement>(null);

  useImperativeHandle(ref, () => ({
    trigger: event => {
      if (!event && containerRef.current) {
        createRipple({
          currentTarget: containerRef.current,
        } as React.MouseEvent<HTMLSpanElement>);
      } else {
        createRipple(event);
      }
    },
  }));

  return (
    <span
      ref={containerRef}
      className={styles.rippleContainer}
      aria-hidden="true"
    >
      {ripples.map(ripple => (
        <span
          className={styles.ripple}
          key={ripple.id}
          style={ripple.style}
          data-testid="ripple-element"
        />
      ))}
    </span>
  );
});

Ripple.displayName = 'Ripple';
